import { IStyle, classNamesFunction } from '@fluentui/react';
import { isGetHelpSourceApp } from '../../../../web/utils/statelessUtil';
import { IAppNavProps } from '../presentationalComponents/Navigation';

export interface IFormHeaderStyles {
  formColLgTen: IStyle;
  formSearchHelpMainHeader: IStyle;
  row: IStyle;
}

export const getFormHeaderStyles = (props: IAppNavProps): IFormHeaderStyles => {
  const { isNonAgave, appName } = props;
  return {
    formColLgTen: {
      position: 'relative',
      minHeight: '1px',
      alignItems: 'stretch',
      float: 'left',
      width: '100%',
      padding: '0',
      marginLeft: '0',
      marginRight: '0',
    },
    formSearchHelpMainHeader: {
      marginTop: isNonAgave ? '8px' : isGetHelpSourceApp(appName) ? '20px' : '28px',
      marginBottom: isGetHelpSourceApp(appName) ? '20px' : '15px',
    },
    row: {
      padding: '0',
      margin: '0',
      fontSize: '100% !important',
      selectors: {
        '::before': {
          display: 'table',
          content: "''",
          boxSizing: 'borderBox',
        },
        '::after': {
          clear: 'both',
          display: 'table',
          content: "''",
          boxSizing: 'borderBox',
        },
      },
    },
  };
};

export const getFormHeaderClassNames = classNamesFunction<{}, IFormHeaderStyles>();
